<template>
  <div id="app" v-cloak>
    <Header v-show="isShow"></Header>
    <!-- 占位符 -->
    <div class="placeholder" v-show="isShow"></div>
    <router-view />
    <Footer v-show="isShow"></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      isShow: true,
    };
  },
  mounted() {
    
  },
  methods: {
    
  },
  watch: {
    $route(next) {
      // console.log("app.vue", next);
      if (["/login"].includes(next.path)) {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    },
  }
};
</script>

<style lang="scss">
// 引入全局公共样式
@import "./assets/css/common.css";
@import "./assets/css/style.scss";

.placeholder {
  width: 100%;
  height: 80px;
}
.pt20{
  padding-top: 20px;
}

</style>
